// extracted by mini-css-extract-plugin
export default {"row":"settings_row__u90YD"};